import { Button, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import ModalV2 from '/@/components/bayer/modal-v2';
import { useDeleteFieldMutation } from '/@/hooks/fields';
import { _ } from '/@/locale';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';

const DeleteFieldModal = ({
    fieldId,
    onSuccess,
    open,
    setOpen,
}: {
    fieldId: number;
    onSuccess: () => void;
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const deleteFieldMutation = useDeleteFieldMutation(fieldId);
    const handleDeleteField = async () => {
        try {
            await deleteFieldMutation.trigger();
            onSuccess();
            setOpen(false);
            mpTrackEvent('Field deleted', undefined);
            enqueueSnackbar(_('Lote eliminado correctamente'), {
                variant: 'success',
                SnackbarProps: { 'data-testid': 'delete-field-modal-snackbar-success' },
            });
        } catch (error) {
            enqueueSnackbar(_('Error al eliminar el lote'), {
                variant: 'error',
            });
        }
    };

    return (
        <ModalV2
            open={open}
            setOpen={setOpen}
            title={_('Eliminar lote')}
            description={_('¿Estás seguro que querés eliminar este lote?')}
            actions={
                <>
                    <Button
                        variant='text'
                        color='secondary'
                        onClick={() => handleDeleteField()}
                        loading={deleteFieldMutation.isMutating}
                        disabled={deleteFieldMutation.isMutating}
                        data-testid='delete-field-modal-button-delete'
                    >
                        {_('Eliminar')}
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        onClick={() => setOpen(false)}
                        disabled={deleteFieldMutation.isMutating}
                    >
                        {_('Cancelar')}
                    </Button>
                </>
            }
            actionsProps={{
                justifyContent: 'end',
            }}
        >
            <Typography variant='body1' color='primary'>
                {_('Una vez eliminado el lote, no podrás recuperarlo.')}
            </Typography>
        </ModalV2>
    );
};

export default DeleteFieldModal;
